export const UPDATE_GAME_VERIFY_LOADING = "UPDATE_GAME_VERIFY_LOADING"
export const UPDATE_GAME_VERIFY_PHONE = "UPDATE_GAME_VERIFY_PHONE"
export const UPDATE_GAME_VERIFY_REQUEST = "UPDATE_GAME_VERIFY_REQUEST"
export const UPDATE_GAME_VERIFY_REQUEST_FORM = "UPDATE_GAME_VERIFY_REQUEST_FORM"